
import { provideRouter } from '@angular/router';
import { provideEffects } from '@ngrx/effects';
import { MetaReducer, Action, provideState } from '@ngrx/store';
import { createLocalStorageSyncReducer } from '../../shared/utils/local-storage-sync';
import { DomainAllowlistRoutes } from './domain-allowlist.routing';
import { DomainAllowlistFacade } from './facade/domain-allowlist.facade';
import { DomainAllowlistService } from './service/domain-allowlist.service';
import { domainAllowlistStateKey } from './state';
import { DomainAllowlistEffects } from './state/effects/domain-allowlist.effects';
import { DomainAllowlistState, DomainAllowlistReducer } from './state/reducers/domain-allowlist.reducer';

const domainLocalStorageSyncReducer = createLocalStorageSyncReducer<DomainAllowlistState>(['domainAllowlist']);

const domainMetaReducers: Array<MetaReducer<DomainAllowlistState, Action>> = [domainLocalStorageSyncReducer];

export const domainAllowlistConfig = [
  provideState(domainAllowlistStateKey, DomainAllowlistReducer, { metaReducers: domainMetaReducers }),
  provideEffects([DomainAllowlistEffects]),
  provideRouter(DomainAllowlistRoutes),
  DomainAllowlistFacade,
  DomainAllowlistService,
];
